import { POLL_START, POLL_STOP, UPDATE_POLLING_STATS } from 'constants/actionTypes';

const startPolling = config => ({
    type: POLL_START,
    config,
});

const stopPolling = () => ({
    type: POLL_STOP,
});

const updatePollingStats = stats => ({
    type: UPDATE_POLLING_STATS,
    stats,
});

export { startPolling, stopPolling, updatePollingStats };
